import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function PainSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-541">
      <div className="max-w-copy mx-auto" data-id="element-542">
        {/* Section label */}
        <FadeIn data-id="element-543">
          <div className="flex items-center gap-4 mb-14" data-id="element-544">
            <div className="h-px bg-border-accent flex-grow" data-id="element-545" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-546">
              ◆ Opening ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-547" />
          </div>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-primary" data-id="element-548">
          {/* Opening narrative — grouped for smooth reading */}
          <FadeIn data-id="element-549">
            <p data-id="element-550">
              There are moments the news covers for 48 hours. And then we bury
              them under the next news cycle.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-551">
            <p data-id="element-552">
              On September 10, 2025, a man was killed in a university auditorium
              in Utah while defending the right to debate ideas out loud.
            </p>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-553">
            <p className="font-display text-2xl md:text-3xl font-bold text-text-primary py-2" data-id="element-554">
              His name was Charlie Kirk.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-555">
            <p data-id="element-556">
              What followed — the reactions, the vigils, the complicit silence
              of certain media outlets, the indignation of millions — lasted
              less than a week in the public conversation.
            </p>
          </FadeIn>

          {/* Blockquote */}
          <FadeIn delay={0.25} data-id="element-557">
            <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 my-12" data-id="element-558">
              <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-559">
                This book exists because some stories deserve more than 48
                hours.
              </p>
            </div>
          </FadeIn>

          {/* Mid-section CTA — secondary, less aggressive */}
          <FadeIn delay={0.3} data-id="element-560">
            <div className="flex flex-col items-center my-4" data-id="element-561">
              <Button href="#offer" variant="secondary" className="w-full md:w-auto text-sm md:text-base" data-id="element-562">
                Get The Book That Fills The Gap &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-3 tracking-wide" data-id="element-563">
                Digital. Immediate. Permanent.
              </p>
            </div>
          </FadeIn>

          {/* Divider between Opening and Pain */}
          <FadeIn data-id="element-564">
            <div className="flex items-center gap-4 mt-20 mb-14" data-id="element-565">
              <div className="h-px bg-border-accent flex-grow" data-id="element-566" />
              <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-567">
                ◆ The Pain ◆
              </span>
              <div className="h-px bg-border-accent flex-grow" data-id="element-568" />
            </div>
          </FadeIn>

          {/* "You felt it" — emotional anchor */}
          <FadeIn data-id="element-569">
            <p className="font-display text-3xl md:text-4xl font-bold text-text-primary" data-id="element-570">
              You felt it.
            </p>
          </FadeIn>

          {/* Emotional escalation — grouped for rhythm */}
          <FadeIn delay={0.1} data-id="element-571">
            <div className="space-y-6" data-id="element-572">
              <p data-id="element-573">
                That strange discomfort when a story this big disappears from
                the feed in seventy-two hours.
              </p>
              <p data-id="element-574">
                When you realize the headlines were written for the click — not
                for the understanding.
              </p>
              <p data-id="element-575">
                When the people who should have spoken up went quiet. And the
                people who spoke said nothing of substance.
              </p>
            </div>
          </FadeIn>

          {/* Desire — what they wanted */}
          <FadeIn delay={0.15} data-id="element-576">
            <div className="space-y-6" data-id="element-577">
              <p className="text-text-primary font-medium" data-id="element-578">
                You wanted the full picture. You wanted context. History. Depth.
              </p>
              <p data-id="element-579">You wanted someone to take this seriously.</p>
            </div>
          </FadeIn>

          {/* Contrast — what they got instead */}
          <FadeIn delay={0.2} data-id="element-580">
            <p data-id="element-581">
              And instead, you got trending hashtags and a news cycle that moved
              on to the next outrage before the echo of the first had faded.
            </p>
          </FadeIn>

          {/* The bridge — key selling line */}
          <FadeIn delay={0.25} data-id="element-582">
            <p className="font-display text-xl md:text-2xl italic text-accent-soft leading-relaxed mt-8" data-id="element-583">
              That gap — between what happened and what was actually explained —
              is exactly what this book was built to fill.
            </p>
          </FadeIn>

          {/* Closing CTA — strong, primary, with card treatment */}
          <FadeIn delay={0.3} data-id="element-584">
            <div className="flex flex-col items-center mt-16 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-585">
              <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-586">
                Don't let it disappear.
              </p>
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-587">
                Own The Memorial &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-588">
                Instant access. Permanent download.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}